import { Injectable } from "@angular/core";
import { BaseMapperWithSerializer } from "../../base.mapper";
import { PostUserRequestModel } from "../../../models/apis/system/user/post-user-request.model";
import { DataResponseHttp } from "../../../http-models/data-response.http";
import { UserHttp } from "../../../http-models/systems/user/user.http";
import { DataResponseModel } from "../../../models/apis/data-response.model";
import { UserModel } from "../../../models/apis/system/user/user.model";


@Injectable({
    providedIn: 'root',
})
export class PostUserMapper implements BaseMapperWithSerializer
<PostUserRequestModel, FormData, DataResponseModel<UserModel>, DataResponseHttp<UserHttp>> {

    convertTo(model: PostUserRequestModel): FormData {
        const request: FormData = new FormData();
        request.append("email", model.email);
        request.append("firstName", model.firstName);
        request.append("gender", model.gender.toString());

        if (model.lastName) {
            request.append("lastName", model.lastName);
        }

        if (model.birthDay) {
            request.append("birthDay", model.birthDay);
        }

        if (model.designation) {
            request.append("designation", model.designation);
        }

        if (model.costCenter) {
            request.append("costCenter", model.costCenter);
        }

        if (model.contactNumber) {
            request.append("contactNumber", model.contactNumber);
        }

        if (model.landingPage) {
            request.append("landingPage", model.landingPage);
        }

        request.append("isSidebarCollapsedOnPageLoad", model.isSidebarCollapsedOnPageLoad.toString());

        if (model.skin) {
            request.append("skin", model.skin);
        }


        if (model.picture) {
            request.append("picture", model.picture, model.pictureFileName);
        }

        request.append("isAdminUser", model.isAdminUser.toString());

        if (model.defaultHospitalId) {
            request.append("defaultHospitalId", model.defaultHospitalId.toString());
        }

        if (model.hospitalIds && model.hospitalIds.length > 0) {
            model.hospitalIds.forEach(value => {
                request.append("hospitalIds", value.toString());
            });
        }

        if (model.departmentIds && model.departmentIds.length > 0) {
            model.departmentIds.forEach(value => {
                request.append("departmentIds", value.toString());
            });
        }

        if (model.roleIds && model.roleIds.length > 0) {
            model.roleIds.forEach(value => {
                request.append("roleIds", value.toString());
            });
        }

        return request;
    }

    convertFrom(http: DataResponseHttp<UserHttp>): DataResponseModel<UserModel> {
        let response = {
            isError: http.isError,
            errors: http.errors
        } as DataResponseModel<UserModel>;
        if (http.isError != true && http.data) {
            response.data = {
                id: http.data.id,
                email: http.data.email,
                firstName: http.data.firstName,
                lastName: http.data.lastName ?? '',
                birthDay: http.data.birthDay ?? '',
                designation: http.data.designation ?? '',
                costCenter: http.data.costCenter ?? '',
                contactNumber: http.data.contactNumber ?? '',
                gender: http.data.gender,
                genderCode: http.data.genderCode,
                pictureUrl: http.data.pictureUrl ?? '',
                lastLoginTime: http.data.lastLoginTime ?? '',
                lastIpAddress: http.data.lastIpAddress ?? '',
                isAdminUser: http.data.isAdminUser,
                userSetting: {
                    ...http.data.userSetting
                },
                hospitals: [],
                departments: [],
                roles: [],
                isActive: http.data.isActive,
                createdBy: http.data.createdBy,
                createdDateUtc: new Date(http.data.createdDateUtc),
                updatedBy: http.data.updatedBy,
                updatedDateUtc: new Date(http.data.updatedDateUtc)
            } as UserModel;
            if (http.data.hospitals && http.data.hospitals.length > 0) {
                http.data.hospitals.forEach(value => {
                    response.data.hospitals.push({
                        id: value.id,
                        name: value.name,
                        code: value.code,
                        address1: value.address1 ?? '',
                        address2: value.address2 ?? '',
                        contactNumber: value.contactNumber ?? '',
                        halalPrinterName: value.halalPrinterName ?? '',
                        nonHalalPrinterName: value.nonHalalPrinterName ?? '',
                        pictureCollapsedUrl: value.pictureCollapsedUrl ?? '',
                        pictureExpandedUrl: value.pictureExpandedUrl ?? '',
                        isActive: value.isActive,
                        createdBy: value.createdBy,
                        createdDateUtc: new Date(value.createdDateUtc),
                        updatedBy: value.updatedBy,
                        updatedDateUtc: new Date(value.updatedDateUtc),
                        useMealUpgradeOption: value.useMealUpgradeOption,
                        mealUpgradeOption: value.mealUpgradeOption,
                        autoOrderTea: value.autoOrderTea,
                        autoOrderTeaFollowPrevMeal: value.autoOrderTeaFollowPrevMeal,
                        autoOrderMealClass: value.autoOrderMealClass,
                        autoOrderForPlanned: value.autoOrderForPlanned,
                        autoOrderMail: value.autoOrderMail,
                        pbtBehaviorOption: value.pbtBehaviorOption,
                        pbtShowGuestMealOrderOption: value.pbtShowGuestMealOrderOption,
                        showQrCodeinMealSlip: value.showQrCodeinMealSlip,
                        enableDns153: value.enableDns153
                    });
                });
            }
            if (http.data.departments && http.data.departments.length > 0) {
                http.data.departments.forEach(value => {
                    response.data.departments.push({
                        id: value.id,
                        name: value.name,
                        code: value.code,
                        hospitalId: value.hospitalId,
                        hospitalName: value.hospitalName,
                        costCentreId: value.costCentreId,
                        costCentreName: value.costCentreName,
                        isActive: value.isActive,
                        createdBy: value.createdBy,
                        createdDateUtc: new Date(value.createdDateUtc),
                        updatedBy: value.updatedBy,
                        updatedDateUtc: new Date(value.updatedDateUtc),
                    });
                });
            }
            if (http.data.roles && http.data.roles.length > 0) {
                http.data.roles.forEach(value => {
                    response.data.roles.push({
                        id: value.id,
                        name: value.name,
                        hospitalId: value.hospitalId,
                        hospitalName: value.hospitalName,
                        accessControlLists: value.accessControlLists,
                        isActive: value.isActive,
                        createdBy: value.createdBy,
                        createdDateUtc: new Date(value.createdDateUtc),
                        updatedBy: value.updatedBy,
                        updatedDateUtc: new Date(value.updatedDateUtc)
                    });
                });
            }
        }
        return response;
    }

}
